const routes = {
  all: "*",
  homepage: "/",
  login: "/login",
  takeDetails: "/take-details",
  reports: "/reports",
};

const apiEndpoints = {
  login: "/login",
  logout: "/user/logout",
  media: "/media",
  getLocation: "/get-directions",
  getTakeDetails: "/user/list-report",
  addTakeDetails: "/user/add-report",
};

const notAllowHeader = [];

const notAllowFooter = [];

const headerChildPages = [];

const companyNames = {
  fog: "fog",
};

const companyConfig = {
  fog_test: {
    name: "fog",
    server: "test",
    checkBrowser: true,
    pages: [routes.takeDetails, routes.reports],
  },
  fog_copy: {
    name: "fog",
    server: "copy",
    checkBrowser: true,
    pages: [routes.takeDetails, routes.reports],
  },
  fog: {
    name: "fog",
    server: "live",
    checkBrowser: true,
    pages: [routes.takeDetails, routes.reports],
  },
};

export {
  routes,
  apiEndpoints,
  notAllowHeader,
  notAllowFooter,
  companyNames,
  companyConfig,
  headerChildPages,
};
